export default __webpack_public_path__ + "static/media/HHSTSSPrintOutsSmall.980e3fd3.pdf";